var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../components/actor/Aspect_';
import { SortableItem_ } from './SortableItem_';
let SortableList_ = class SortableList_ extends React.PureComponent {
    render() {
        const { sortableList, provided, snapshot } = this.props;
        return (React.createElement(Aspect_, { aspect: sortableList.inner, templateComponent: React.createElement("div", { ref: provided.innerRef, style: {
                    height: 200,
                    display: 'flex',
                    flexDirection: sortableList.direction === 'horizontal' ? 'row' : 'column',
                    padding: 8,
                    overflow: 'auto',
                }, ...provided.droppableProps }) },
            sortableList.listItems.visibleSortableItems.map((item, itemIndex) => (React.createElement(SortableItem_, { sortableItem: item, itemIndex: itemIndex, key: item.id }))),
            provided.placeholder));
    }
};
SortableList_ = __decorate([
    observer
], SortableList_);
export { SortableList_ };
